import { GlobalConfig } from ".";
import { getAuthContext } from "./getAutContext";
let Context;
export function init(config) {
    if (!Object.isFrozen(GlobalConfig)) {
        GlobalConfig.config = Object.assign(Object.assign({}, GlobalConfig.config), config);
        Object.freeze(GlobalConfig);
        if (!Object.isFrozen(Context) || Context === undefined) {
            Context = getAuthContext(GlobalConfig.config);
            Context.Subscriptions.forEach(x => x.subscribe());
            Context.Gateway.init();
            Object.freeze(Context);
        }
    }
    else {
        console.warn("Already initialized");
    }
}
export function getToken() {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    return Context.Gateway.getToken();
}
;
export function getPlatformJwtManager() {
    if (!Object.isFrozen(GlobalConfig) || Context === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    return Context.PlatformJwtManager;
}
;
//# sourceMappingURL=init.js.map